"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientNotificationType = void 0;
var ClientNotificationType;
(function (ClientNotificationType) {
    ClientNotificationType["viewDailyPrompt"] = "viewDailyPrompt";
    ClientNotificationType["viewDimensionResults"] = "viewDimensionResults";
    ClientNotificationType["viewProfile"] = "viewProfile";
    ClientNotificationType["viewGenericModal"] = "viewGenericModal";
    ClientNotificationType["viewPeerEndorsements"] = "viewPeerEndorsements";
    ClientNotificationType["viewPersonalInsight"] = "viewPersonalInsight";
    ClientNotificationType["viewConnectionTraitPage"] = "viewConnectionTraitPage";
    ClientNotificationType["viewStory"] = "viewStory";
    ClientNotificationType["viewEndorsementDigest"] = "viewEndorsementDigest";
    ClientNotificationType["viewSnippet"] = "viewSnippet";
    ClientNotificationType["viewFeatureCarousel"] = "viewFeatureCarousel";
    ClientNotificationType["viewTraitRatingModal"] = "viewTraitRatingModal";
    ClientNotificationType["viewPremiumConversionModal"] = "viewPremiumConversionModal";
    ClientNotificationType["viewPersonalityAnalysis"] = "viewPersonalityAnalysis";
    ClientNotificationType["viewDailyPoll"] = "viewDailyPoll";
    ClientNotificationType["viewCommentThread"] = "viewCommentThread";
    ClientNotificationType["viewCompatibilitySnippet"] = "viewCompatibilitySnippet";
    ClientNotificationType["viewPost"] = "viewPost";
    ClientNotificationType["viewRewards"] = "viewRewards";
    ClientNotificationType["viewPracticePrompt"] = "viewPracticePrompt";
    ClientNotificationType["viewReport"] = "viewReport";
    ClientNotificationType["viewPracticesRoot"] = "viewPracticesRoot";
    ClientNotificationType["viewSimilarity"] = "viewSimilarity";
    ClientNotificationType["viewCompatibility"] = "viewCompatibility";
    ClientNotificationType["viewArchetype"] = "viewArchetype";
    ClientNotificationType["viewNatureBreakdown"] = "viewNatureBreakdown";
    ClientNotificationType["viewFeed"] = "viewFeed";
    ClientNotificationType["surveyLinkReceived"] = "surveyLinkReceived";
    ClientNotificationType["viewDoppelganger"] = "viewDoppelganger";
    ClientNotificationType["viewPeerAssessment"] = "viewPeerAssessment";
    ClientNotificationType["viewPracticeIntro"] = "viewPracticeIntro";
    ClientNotificationType["viewPeerFeedbackLevelsModal"] = "viewPeerFeedbackLevelsModal";
    ClientNotificationType["viewDailyStory"] = "viewDailyStory";
    ClientNotificationType["viewPeriodicQuiz"] = "viewPeriodicQuiz";
    ClientNotificationType["viewPeriodicInsight"] = "viewPeriodicInsight";
    ClientNotificationType["periodicQuizResultShared"] = "periodicQuizResultShared";
    ClientNotificationType["weeklyPublicProfileViews"] = "weeklyPublicProfileViews";
    ClientNotificationType["viewDeliveredDailyInsight"] = "viewDeliveredDailyInsight";
    ClientNotificationType["commentLiked"] = "commentLiked";
    ClientNotificationType["commentReplied"] = "commentReplied";
    ClientNotificationType["firstComment"] = "firstComment";
    ClientNotificationType["viewUserPoll"] = "viewUserPoll";
    ClientNotificationType["viewDeliveredDailyStoryNew"] = "viewDeliveredDailyStoryNew";
    ClientNotificationType["postLiked"] = "postLiked";
    ClientNotificationType["connectionPostCreated"] = "connectionPostCreated";
    ClientNotificationType["postCommented"] = "postCommented";
    ClientNotificationType["viewCommunityQuestion"] = "viewCommunityQuestion";
    ClientNotificationType["viewPeerStory"] = "viewPeerStory";
    ClientNotificationType["viewScheduledAssessment"] = "viewScheduledAssessment";
})(ClientNotificationType = exports.ClientNotificationType || (exports.ClientNotificationType = {}));
